import { render, staticRenderFns } from "./ContractRecognitionShow.vue?vue&type=template&id=e24da5c0"
import script from "./ContractRecognitionShow.vue?vue&type=script&lang=js"
export * from "./ContractRecognitionShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports